export const fmtDate = (d) => d.toLocaleDateString("id-ID", { day: "2-digit", month: "long", year: "numeric" });

// Departure + 6 months (clamped to month end) + 20 days
export const minExpiry = (dep) => {
  const target = new Date(dep.getFullYear(), dep.getMonth() + 6, 1);
  const last = new Date(target.getFullYear(), target.getMonth() + 1, 0).getDate();
  target.setDate(Math.min(dep.getDate(), last));
  target.setDate(target.getDate() + 20);
  return target;
};

export const gap = (from, to) => {
  if (to < from) return "Sudah habis sebelum berangkat";
  let months = (to.getFullYear() - from.getFullYear()) * 12 + to.getMonth() - from.getMonth();
  if (to.getDate() < from.getDate()) months -= 1;
  const anchor = new Date(from.getFullYear(), from.getMonth() + months, from.getDate());
  const days = Math.round((to - anchor) / 86400000);
  return `${months} bulan ${days} hari`;
};
